// relies on the sentry loader script
// https://docs.sentry.io/platforms/javascript/install/loader/
// which loads most of sentry on demand
// and is injected in `javascript_templates/core.jinja` if `use_sentry_loader` is set in the template context
import pickBy from "lodash/pickBy";
import { getRequestScore, shouldFilterRequest } from "web/react/utils/request-filter";
import globals from "web/script/modules/globals";

const Sentry = (window as any).Sentry;

function setupSentryWhenLoaded(): void {
    const { environment, data } = globals.window.Lyst!;
    const release = `web-frontend@${(environment?.release_sha || "").substring(0, 8)}`;

    Sentry.init({
        release,
        environment: environment.sentryEnvironment,
        tracesSampleRate: 0.0,
        initialScope: {
            tags: {
                country: environment.country,
                language: environment.language,
                currency: environment.currencyProps?.currencyCode,
                page_sub_type: data?.pageSubType,
                page_type: data?.pageType,
                logged_in: environment.userLoggedIn ? "yes" : "no",
                cfbs: getRequestScore() ?? undefined,
            },
            extra: {
                features: pickBy(data?.features),
            },
        },
        ignoreErrors: ["Event `ErrorEvent` captured as exception with message `Script error.`"],
        // When the ad blocker is on, google conversion tag throws an error
        // when trying to send events. This will stop sending these errors
        // to Sentry.
        beforeSend: (event) => {
            if (shouldFilterRequest()) {
                return null;
            }

            try {
                const values = event.exception?.values || [];
                const frames = values[0]?.stacktrace?.frames || [];
                // just so as not to have to assert each link in the chain
                if (frames[0].filename?.includes("/pagead/viewthroughconversion/")) {
                    return null;
                }
            } catch (error) {
                console.error(error);
            }

            return event;
        },
    });
}

export function setupSentry(): void {
    // sentry not loaded, e.g. local dev
    if (typeof Sentry === "undefined") {
        return;
    }

    Sentry.onLoad(setupSentryWhenLoaded);
}
